export default __webpack_public_path__ + "static/media/Decoration Import Template.f8642894.csv";